export enum SurplusType {
  CHARGEBACK = 'CHARGEBACK',
  REPAYMENT = 'REPAYMENT',
  REFUND = 'REFUND',
  PAYOUT = 'PAYOUT',
}
